import { LitElement, html } from 'lit';
import Styles from './vm-profile-image.scss';

export default class VmProfileImage extends LitElement {
    static styles = Styles;

    static properties = {
        userName: { type: String },
        imageSrc: { type: String },
        imageAlt: { type: String },
        link: { type: String },
    };

    constructor() {
        super();
        this.userName = 'Vumedi User';
    }

    render() {
        const name = this.userName || 'Vumedi User';

        if (this.imageSrc) {
            return html`
                <figure class="vm-profile-image" part="figure">
                    <img src="${this.imageSrc}" alt="${this.imageAlt || `${name} profile image`}" part="image" />
                    ${this.link ? html`<a href="${this.link}" part="link"></a>` : ''}
                </figure>
            `;
        }

        return html`
            <span class="vm-profile-image vm-profile-image--initials" part="initials">
                ${name.slice(0, 1).toUpperCase()} ${this.link ? html`<a href="${this.link}" part="link"></a>` : ''}
            </span>
        `;
    }
}
